import axios from "axios";
const jsonConfig = require("../../config.json");

const  getModelChartData = async (payload) =>{
    try{
    const getAllResponse = await axios.post(jsonConfig.apiUrl + "modelefficiencypieChart",payload, {
           headers: {
             "x-functions-key": jsonConfig.key,
          },
        });
  

        return Promise.resolve(getAllResponse)

    }catch (error) {
       return Promise.reject(error)
    }
  }
export default  getModelChartData;